<template>
  <div>
    <form @submit.prevent="handleCreateDriver">
      <div class="md-layout md-gutter">
        <div class="md-layout-item md-large-size-50 md-xlarge-size-50 md-medium-size-50 md-small-size-100 md-xsmall-size-100">
          <div class="md-layout">
            <div class="md-layout-item md-large-size-50 md-xlarge-size-50 md-medium-size-50 md-small-size-100 md-xsmall-size-100">
              <md-field :class="{'md-invalid': errors['instance.DriverID']}">
                <label>Citizen ID</label>
                <md-input v-model="formData.DriverID" @blur="checkDriver($event.target.value)"></md-input>
                <span class="md-error" v-if="errors['instance.DriverID']">Invalid field input</span>
              </md-field>
            </div>
            <div class="md-layout-item md-large-size-50 md-xlarge-size-50 md-medium-size-50 md-small-size-100 md-xsmall-size-100">
              <div style="display: flex;">
                <md-avatar class="md-large" v-show="formData.DriverPhoto">
                  <my-s3-image :imagePath="formData.DriverPhoto"></my-s3-image>
                </md-avatar>
                <md-field :class="{'md-invalid': errors['instance.DriverPhoto']}">
                  <md-file v-model="imageSelect" accept="image/*" @md-change="handleImageSelect" placeholder="Driver Photo" />
                  <span class="md-error" v-if="errors['instance.DriverPhoto']">Invalid field input</span>
                </md-field>
              </div>
            </div>
          </div>
        </div>
        <div class="md-layout-item md-large-size-25 md-xlarge-size-25 md-medium-size-25 md-small-size-100 md-xsmall-size-100">
          <md-field :class="{'md-invalid': errors['instance.DriverName']}">
            <label>Driver Name</label>
            <md-input v-model="formData.DriverName"></md-input>
            <span class="md-error" v-if="errors['instance.DriverName']">Invalid field input</span>
          </md-field>
        </div>
        <div class="md-layout-item md-large-size-25 md-xlarge-size-25 md-medium-size-25 md-small-size-100 md-xsmall-size-100">
          <md-field>
            <label for="DriverGroup">Driver Group</label>
            <md-select v-model="formData.DriverGroup" name="DriverGroup" id="DriverGroup">
              <md-option value="Freelance">Freelance</md-option>
              <md-option value="Permanent">Permanent</md-option>
              <md-option value="Truck Leader">Truck Leader</md-option>
              <md-option value="EZIE Certified">EZIE Certified</md-option>
            </md-select>
          </md-field>
        </div>
        <div class="md-layout-item md-large-size-25 md-xlarge-size-25 md-medium-size-25 md-small-size-100 md-xsmall-size-100">
          <md-field :class="{'md-invalid': errors['instance.DriverLicenseID']}">
            <label>Driver License ID</label>
            <md-input v-model="formData.DriverLicenseID"></md-input>
            <span class="md-error" v-if="errors['instance.DriverLicenseID']">Invalid field input</span>
          </md-field>
        </div>
        <div class="md-layout-item md-large-size-25 md-xlarge-size-25 md-medium-size-25 md-small-size-100 md-xsmall-size-100">
          <md-datepicker v-model="formData.DriverLicenseExpire" :md-model-type="String" :class="{'md-invalid': errors['instance.DriverLicenseExpire']}" md-immediately>
            <label>Driver License Expires</label>
            <span class="md-error" v-if="errors['instance.DriverLicenseExpire']">Invalid field input</span>
          </md-datepicker>
        </div>
        <div class="md-layout-item md-large-size-25 md-xlarge-size-25 md-medium-size-25 md-small-size-100 md-xsmall-size-100">
          <div style="display: flex;">
            <md-avatar class="md-large" v-show="formData.DriverLicensePhoto">
              <my-s3-image :imagePath="formData.DriverLicensePhoto"></my-s3-image>
            </md-avatar>
            <md-field :class="{'md-invalid': errors['instance.DriverLicensePhoto']}">
              <md-file accept="image/*" @md-change="handleLicenseImageSelect" placeholder="License Photo" />
              <span class="md-error" v-if="errors['instance.DriverLicensePhoto']">Invalid field input</span>
            </md-field>
          </div>
        </div>
        <div class="md-layout-item md-large-size-25 md-xlarge-size-25 md-medium-size-25 md-small-size-100 md-xsmall-size-100">
          <md-field :class="{'md-invalid': errors['instance.DriverMonthlySalary']}">
            <label>Monthly Salary</label>
            <md-input v-model.number="formData.DriverMonthlySalary"></md-input>
            <span class="md-error" v-if="errors['instance.DriverMonthlySalary']">Invalid field input</span>
          </md-field>
        </div>
        <div class="md-layout-item md-large-size-50 md-xlarge-size-50 md-medium-size-50 md-small-size-100 md-xsmall-size-100">
          <md-field :class="{'md-invalid': errors['instance.DriverAddress']}">
            <label>Address</label>
            <md-input v-model="formData.DriverAddress"></md-input>
            <span class="md-error" v-if="errors['instance.DriverAddress']">Invalid field input</span>
          </md-field>
        </div>
        <div class="md-layout-item md-large-size-25 md-xlarge-size-25 md-medium-size-25 md-small-size-100 md-xsmall-size-100">
          <md-autocomplete v-model="formData.DriverBankName" :md-options="bankOptions" :class="{'md-invalid': errors['instance.DriverBankName']}">
            <label>Bank</label>
            <span class="md-error" v-if="errors['instance.DriverBankName']">Invalid field input</span>
          </md-autocomplete>
        </div>
        <div class="md-layout-item md-large-size-25 md-xlarge-size-25 md-medium-size-25 md-small-size-100 md-xsmall-size-100">
          <md-field :class="{'md-invalid': errors['instance.DriverBankBranchCode']}">
            <label>Bank Branch Code</label>
            <md-input v-model="formData.DriverBankBranchCode"></md-input>
            <span class="md-error" v-if="errors['instance.DriverBankBranchCode']">Invalid field input</span>
          </md-field>
        </div>
        <div class="md-layout-item md-large-size-25 md-xlarge-size-25 md-medium-size-25 md-small-size-100 md-xsmall-size-100">
          <md-field :class="{'md-invalid': errors['instance.DriverBankAccountName']}">
            <label>Bank Account Name</label>
            <md-input v-model="formData.DriverBankAccountName"></md-input>
            <span class="md-error" v-if="errors['instance.DriverBankAccountName']">Invalid field input</span>
          </md-field>
        </div>
        <div class="md-layout-item md-large-size-25 md-xlarge-size-25 md-medium-size-25 md-small-size-100 md-xsmall-size-100">
          <md-field :class="{'md-invalid': errors['instance.DriverBankAccountNumber']}">
            <label>Bank Account NO.</label>
            <md-input v-model="formData.DriverBankAccountNumber"></md-input>
            <span class="md-error" v-if="errors['instance.DriverBankAccountNumber']">Invalid field input</span>
          </md-field>
        </div>
        <div class="md-layout-item md-large-size-25 md-xlarge-size-25 md-medium-size-25 md-small-size-100 md-xsmall-size-100">
          <md-field :class="{'md-invalid': errors['instance.DriverPhoneNumber']}">
            <label>Phone</label>
            <md-input v-model="formData.DriverPhoneNumber"></md-input>
            <span class="md-error" v-if="errors['instance.DriverPhoneNumber']">Invalid field input</span>
          </md-field>
        </div>
        <div class="md-layout-item md-large-size-25 md-xlarge-size-25 md-medium-size-25 md-small-size-100 md-xsmall-size-100">
          <md-field :class="{'md-invalid': errors['instance.DriverEmail']}">
            <label>Email</label>
            <md-input v-model="formData.DriverEmail"></md-input>
            <span class="md-error" v-if="errors['instance.DriverEmail']">Invalid field input</span>
          </md-field>
        </div>
        <div class="md-layout-item md-large-size-25 md-xlarge-size-25 md-medium-size-25 md-small-size-100 md-xsmall-size-100">
          <md-field :class="{'md-invalid': errors['instance.DriverDepositAmount']}">
            <label>Deposit Amount</label>
            <md-input v-model.number="formData.DriverDepositAmount"></md-input>
            <span class="md-error" v-if="errors['instance.DriverDepositAmount']">Invalid field input</span>
          </md-field>
        </div>
        <div class="md-layout-item md-large-size-25 md-xlarge-size-25 md-medium-size-25 md-small-size-100 md-xsmall-size-100">
          <md-field :class="{'md-invalid': errors['instance.DriverBookBankPhoto']}">
            <label>Bookbank</label>
            <div style="display: flex">
              <md-avatar class="md-large" v-show="formData.DriverBookBankPhoto">
                <my-s3-image :imagePath="formData.DriverBookBankPhoto"></my-s3-image>
              </md-avatar>
              <md-file v-model="bookBankimageSelect" accept="image/*" @md-change="handleBookBankImageSelect" placeholder="Bookbank" />
            </div>
            <span class="md-error" v-if="errors['instance.DriverBookBankPhoto']">Invalid field input</span>
          </md-field>
        </div>
        <div class="md-layout-item md-large-size-25 md-xlarge-size-25 md-medium-size-25 md-small-size-100 md-xsmall-size-100">
          <md-field :class="{'md-invalid': errors['instance.NoDiaryPD']}">
            <label>No diary PD</label>
            <md-input v-model.number="formData.NoDiaryPD"></md-input>
            <span class="md-error" v-if="errors['instance.NoDiaryPD']">Invalid field input</span>
          </md-field>
        </div>
        <div class="md-layout-item md-large-size-25 md-xlarge-size-25 md-medium-size-25 md-small-size-100 md-xsmall-size-100">
          <md-autocomplete v-model="formData.DriverTeam" :md-options="driverTeamOptions" :class="{'md-invalid': errors['instance.DriverTeam']}">
            <label>Team</label>
            <span class="md-error" v-if="errors['instance.DriverTeam']">Invalid field input</span>
          </md-autocomplete>
        </div>
        <div class="md-layout-item md-large-size-25 md-xlarge-size-25 md-medium-size-25 md-small-size-100 md-xsmall-size-100">         
          <md-field>
            <label for="movies">Tags</label>
            <md-select v-model="formData.DriverTags" multiple>
              <md-option v-for="tag in driverTagOptions" :value="tag" :key="tag">{{tag}}</md-option>
            </md-select>
            <span class="md-error" v-if="errors['instance.DriverTags']">Invalid field input</span>
          </md-field>
        </div>
        <div class="md-layout-item md-large-size-25 md-xlarge-size-25 md-medium-size-25 md-small-size-100 md-xsmall-size-100">         
          <md-datepicker :value="formData.BeginDate" :md-model-type="String" :class="{'md-invalid': errors['instance.BeginDate']}" md-immediately >
            <label>Begin Date</label>
            <span class="md-error" v-if="errors['instance.BeginDate']">Invalid field input</span>
          </md-datepicker>
        </div>
        <div class="md-layout-item md-large-size-25 md-xlarge-size-25 md-medium-size-25 md-small-size-100 md-xsmall-size-100">         
          <md-field :class="{'md-invalid': errors['instance.RecruitedBy']}">
            <label>Recruited By</label>
            <md-select v-model="formData.RecruitedBy">
              <md-option v-for="user in userOptions" :value="user" :key="user">{{user}}</md-option>
            </md-select>
          </md-field>
        </div>
        <div class="md-layout-item md-large-size-25 md-xlarge-size-25 md-medium-size-25 md-small-size-100 md-xsmall-size-100">         
          <md-field :class="{'md-invalid': errors['instance.ApprovedBy']}">
            <label>Approved By</label>
            <md-select v-model="formData.ApprovedBy">
              <md-option v-for="user in userOptions" :value="user" :key="user">{{user}}</md-option>
            </md-select>
          </md-field>
        </div>
        <div class="md-layout-item md-large-size-25 md-xlarge-size-25 md-medium-size-25 md-small-size-100 md-xsmall-size-100">         
          <md-field :class="{'md-invalid': errors['instance.Status']}">
            <label>Status</label>
            <md-select v-model="formData.Status">
              <md-option value="Active">Active</md-option>
              <md-option value="Inactive">Inactive</md-option>
            </md-select>
          </md-field>
        </div>
        <div class="md-layout-item md-large-size-100 md-xlarge-size-100 md-medium-size-100 md-small-size-100 md-xsmall-size-100">
          <div style="display: flex;">
            <h3>Vehicles</h3>
            <md-button class="md-icon-button" @click="handleAddVehicle" v-show="formData.Vehicles.length < 3">
              <md-icon>add</md-icon>
            </md-button>
          </div>
          <md-tabs :md-active-tab="currentVehicleTab">
            <md-tab v-for="(vehicle, idx) in formData.Vehicles" :key="idx" :id="'vehicle-' + idx" :md-label="vehicle.VehicleLicenseNumber || 'New Vehicle'">
              <div class="md-layout">
                <div class="md-layout-item md-large-size-50 md-xlarge-size-50 md-medium-size-50 md-small-size-100 md-xsmall-size-100">
                  <md-field :class="{'md-invalid': errors['instance.Vehicles[' + idx + '].VehicleLicenseNumber']}">
                    <label>License Number</label>
                    <md-input v-model="formData.Vehicles[idx].VehicleLicenseNumber"></md-input>
                    <span class="md-error" v-if="errors['instance.Vehicles[' + idx + '].VehicleLicenseNumber']">Invalid field input</span>
                  </md-field>
                </div>
                <div class="md-layout-item md-large-size-45 md-xlarge-size-45 md-medium-size-45 md-small-size-100 md-xsmall-size-100">
                  <md-autocomplete v-model="formData.Vehicles[idx].VehicleLicenseProvince" :md-options="provinces" :class="{'md-invalid': errors['instance.Vehicles[' + idx + '].VehicleLicenseProvince']}">
                    <label>License Province</label>
                  </md-autocomplete>
                  <span class="md-error" v-if="errors['instance.Vehicles[' + idx + '].VehicleLicenseProvince']">Invalid field input</span>
                </div>
                <div class="md-layout-item md-large-size-5 md-xlarge-size-5 md-medium-size-5 md-small-size-100 md-xsmall-size-100">
                  <md-button class="md-icon-button" @click="handleDeleteVehicle(idx)">
                    <md-icon>remove</md-icon>
                  </md-button>
                </div>
                <div class="md-layout-item md-large-size-50 md-xlarge-size-50 md-medium-size-50 md-small-size-100 md-xsmall-size-100">
                  <md-field :class="{'md-invalid': errors['instance.Vehicles[' + idx + '].VehicleStatus']}">
                    <label>Status</label>
                    <md-input v-model="formData.Vehicles[idx].VehicleStatus"></md-input>
                    <span class="md-error" v-if="errors['instance.Vehicles[' + idx + '].VehicleStatus']">Invalid field input</span>
                  </md-field>
                </div>
                <div class="md-layout-item md-large-size-50 md-xlarge-size-50 md-medium-size-50 md-small-size-100 md-xsmall-size-100">
                  <md-field :class="{'md-invalid': errors['instance.Vehicles[' + idx + '].VehicleGroup']}">
                    <label>Group</label>
                    <md-input v-model="formData.Vehicles[idx].VehicleGroup"></md-input>
                    <span class="md-error" v-if="errors['instance.Vehicles[' + idx + '].VehicleGroup']">Invalid field input</span>
                  </md-field>
                </div>
                <div class="md-layout-item md-large-size-50 md-xlarge-size-50 md-medium-size-50 md-small-size-100 md-xsmall-size-100">
                  <md-autocomplete v-model="formData.Vehicles[idx].VehicleTruckType" :md-options="truckTypeOptions" :class="{'md-invalid': errors['instance.Vehicles[' + idx + '].VehicleTruckType']}">
                    <label>Truck Type</label>
                    <span class="md-error" v-if="errors['instance.Vehicles[' + idx + '].VehicleTruckType']">Invalid field input</span>
                  </md-autocomplete>
                </div>
                <div class="md-layout-item md-large-size-50 md-xlarge-size-50 md-medium-size-50 md-small-size-100 md-xsmall-size-100">
                  <md-autocomplete v-model="formData.Vehicles[idx].VehicleContainerType" :md-options="containerTypeOptions" :class="{'md-invalid': errors['instance.Vehicles[' + idx + '].VehicleContainerType']}">
                    <label>Container Type</label>
                    <span class="md-error" v-if="errors['instance.Vehicles[' + idx + '].VehicleContainerType']">Invalid field input</span>
                  </md-autocomplete>
                </div>
                <div class="md-layout-item md-large-size-50 md-xlarge-size-50 md-medium-size-50 md-small-size-100 md-xsmall-size-100">
                  <md-field :class="{'md-invalid': errors['instance.Vehicles[' + idx + '].VehicleLoadCapacity']}">
                    <label>Load Capacity</label>
                    <md-input v-model.number="formData.Vehicles[idx].VehicleLoadCapacity"></md-input>
                    <span class="md-error" v-if="errors['instance.Vehicles[' + idx + '].VehicleLoadCapacity']">Invalid field input</span>
                  </md-field>
                </div>
                <div class="md-layout-item md-large-size-50 md-xlarge-size-50 md-medium-size-50 md-small-size-100 md-xsmall-size-100">
                  <md-field :class="{'md-invalid': errors['instance.Vehicles[' + idx + '].VehicleBrand']}">
                    <label>Brand</label>
                    <md-input v-model="formData.Vehicles[idx].VehicleBrand"></md-input>
                    <span class="md-error" v-if="errors['instance.Vehicles[' + idx + '].VehicleBrand']">Invalid field input</span>
                  </md-field>
                </div>
                <div class="md-layout-item md-large-size-50 md-xlarge-size-50 md-medium-size-50 md-small-size-100 md-xsmall-size-100">
                  <md-field :class="{'md-invalid': errors['instance.Vehicles[' + idx + '].VehiclePurchasedYear']}">
                    <label>Purchased Year</label>
                    <md-input v-model.number="formData.Vehicles[idx].VehiclePurchasedYear"></md-input>
                    <span class="md-error" v-if="errors['instance.Vehicles[' + idx + '].VehiclePurchasedYear']">Invalid field input</span>
                  </md-field>
                </div>
                <div class="md-layout-item md-large-size-50 md-xlarge-size-50 md-medium-size-50 md-small-size-100 md-xsmall-size-100">
                  <md-field :class="{'md-invalid': errors['instance.Vehicles[' + idx + '].VehicleInsurranceAmount']}">
                    <label>Insurrance Amount</label>
                    <md-input v-model.number="formData.Vehicles[idx].VehicleInsurranceAmount"></md-input>
                    <span class="md-error" v-if="errors['instance.Vehicles[' + idx + '].VehicleInsurranceAmount']">Invalid field input</span>
                  </md-field>
                </div>
                <div class="md-layout-item md-large-size-50 md-xlarge-size-50 md-medium-size-50 md-small-size-100 md-xsmall-size-100">
                  <md-field :class="{'md-invalid': errors['instance.Vehicles[' + idx + '].VehicleFuelChargePerKM']}">
                    <label>Fuel Charge Per KM</label>
                    <md-input v-model.number="formData.Vehicles[idx].VehicleFuelChargePerKM"></md-input>
                    <span class="md-error" v-if="errors['instance.Vehicles[' + idx + '].VehicleFuelChargePerKM']">Invalid field input</span>
                  </md-field>
                </div>
                <div class="md-layout-item md-large-size-100 md-xlarge-size-100 md-medium-size-100 md-small-size-100 md-xsmall-size-100">
                  Photo
                  <div class="md-layout" v-for="(photo, pid) in formData.Vehicles[idx].VehiclePhoto" :key="pid">
                    <div class="md-layout-item md-large-size-50 md-xlarge-size-50 md-medium-size-50 md-small-size-100 md-xsmall-size-100">
                      <div style="display: flex;">
                        <md-avatar class="md-large" v-show="formData.Vehicles[idx].VehiclePhoto[pid].Path">
                          <my-s3-image :imagePath="formData.Vehicles[idx].VehiclePhoto[pid].Path"></my-s3-image>
                        </md-avatar>
                        <md-field :class="{'md-invalid': errors['instance.Vehicles[' + idx + '].VehiclePhoto.' + pid + '.Path']}">
                          <md-file accept="image/*" @md-change="handleVehicleImageSelect(idx, pid, $event)" placeholder="Photo" />
                          <span class="md-error" v-if="errors['instance.Vehicles[' + idx + '].VehiclePhoto[' + pid + '].Path']">Invalid field input</span>
                        </md-field>
                      </div>
                    </div>
                    <div class="md-layout-item md-large-size-50 md-xlarge-size-50 md-medium-size-50 md-small-size-100 md-xsmall-size-100">
                      <md-field :class="{'md-invalid': errors['instance.Vehicles[' + idx + '].VehiclePhoto[' + pid + '].Caption']}">
                        <label>Caption</label>
                        <md-input v-model="formData.Vehicles[idx].VehiclePhoto[pid].Caption"></md-input>
                        <span class="md-error" v-if="errors['instance.Vehicles[' + idx + '].VehiclePhoto[' + pid + '].Caption']">Invalid field input</span>
                      </md-field>
                    </div>
                  </div>
                </div>
              </div>
            </md-tab>
          </md-tabs>
        </div>
        <div class="md-layout-item md-large-size-50 md-xlarge-size-50 md-medium-size-50 md-small-size-100 md-xsmall-size-100">
          <md-button type="submit" class="md-raised md-primary" v-show="!hideSubmit">
            <span v-show="!$route.params.driverID">Create an Driver</span>
            <span v-show="!!$route.params.driverID">Update an Driver</span>
          </md-button>
          <md-button class="md-raised" @click="$router.go(-1)">Back</md-button>
        </div>
      </div>
      <md-snackbar :md-position="'center'" :md-duration="snackBarDuration" :md-active.sync="showSnackbar" md-persistent>
        <span>{{snackBarMsg}}</span>
      </md-snackbar>
      </form>
  </div>
</template>

<script>
import VueScreenSize from 'vue-screen-size'
import { mapGetters } from 'vuex'
import { API } from 'aws-amplify'
import {validate} from 'jsonschema'
import schema from '../schema'
import MyS3Image from '../components/MyS3Image'
import { NoUnusedVariablesRule } from 'graphql'

export default {
  name: 'DriverForm',
  mixins: [VueScreenSize.VueScreenSizeMixin],
  components: {MyS3Image},
  data () {
    return {
      currentVehicleTab: 'vehicle-0',
      businessTypeOptions: [],
      hideSubmit: false,
      showSnackbar: false,
      snackBarMsg: null,
      snackBarDuration: 4000,
      errors: {},
      imageSelect: null,
      bookBankimageSelect: null,
      userItems: [],
      truckTypeOptions: [],
      containerTypeOptions: [],
      bankOptions: [],
      driverTeamOptions: [],
      driverTagOptions: [],
      provinces: ['กระบี่', 'กรุงเทพฯ', 'กาญจนบุรี', 'กาฬสินธุ์', 'กำแพงเพชร', 'ขอนแก่น', 'จันทบุรี', 'ฉะเชิงเทรา', 'ชลบุรี', 'ชัยนาท', 'ชัยภูมิ', 'ชุมพร', 'เชียงราย', 'เชียงใหม่', 'ตรัง', 'ตราด', 'ตาก', 'นครนายก', 'นครปฐม', 'นครพนม', 'นครราชสีมา', 'นครศรีธรรมราช', 'นครสวรรค์', 'นนทบุรี', 'นราธิวาส', 'น่าน', 'บึงกาฬ', 'บุรีรัมย์', 'ปทุมธานี', 'ประจวบคีรีขันธ์', 'ปราจีนบุรี', 'ปัตตานี', 'พระนครศรีอยุธยา', 'พะเยา', 'พังงา', 'พัทลุง', 'พิจิตร', 'พิษณุโลก', 'เพชรบุรี', 'เพชรบูรณ์', 'แพร่', 'ภูเก็ต', 'มหาสารคาม', 'มุกดาหาร', 'แม่ฮ่องสอน', 'ยโสธร', 'ยะลา', 'ร้อยเอ็ด', 'ระนอง', 'ระยอง', 'ราชบุรี', 'ลพบุรี', 'ลำปาง', 'ลำพูน', 'เลย', 'ศรีสะเกษ', 'สกลนคร', 'สงขลา', 'สตูล', 'สมุทรปราการ', 'สมุทรสงคราม', 'สมุทรสาคร', 'สระแก้ว', 'สระบุรี', 'สิงห์บุรี', 'สุโขทัย', 'สุพรรณบุรี', 'สุราษฎร์ธานี', 'สุรินทร์', 'หนองคาย', 'หนองบัวลำภู', 'อ่างทอง', 'อำนาจเจริญ', 'อุดรธานี', 'อุตรดิตถ์', 'อุทัยธานี', 'อุบลราชธานี'],
      formData: {
        PK: '-',
        SK: '-',
        DriverID: null,
        DriverCitizenID: null,
        DriverName: null,
        DriverAddress: null,
        DriverLicenseID: null,
        DriverLicenseExpire: null,
        DriverLicensePhoto: null,
        DriverPhoto: null,
        DriverPhoneNumber: null,
        DriverEmail: null,
        DriverDepositAmount: null,
        DriverBankName: null,
        DriverBankBranchCode: null,
        DriverBankAccountName: null,
        DriverBankAccountNumber: null,
        DriverBookBankPhoto: null,
        DriverMonthlySalary: null,
        DriverGroup: null,
        DriverTags: [],
        NoDiaryPD: 0,
        DriverTeam: null,
        LineUserID: null,
        RichMenuID: null,
        LineMenuStatus: null,
        ApprovedBy: null,
        BeginDate: null,
        RecruitedBy: null,
        Status: null,
        Vehicles: [{
          PK: '-',
          SK: '-',
          VehicleLicenseNumber: null,
          VehicleLicenseProvince: null,
          VehicleStatus: null,
          VehicleGroup: null,
          VehicleTruckType: null,
          VehicleContainerType: null,
          VehicleLoadCapacity: null,
          VehicleBrand: null,
          VehiclePurchasedYear: null,
          VehicleInsurranceAmount: null,
          VehicleFuelChargePerKM: null,
          VehiclePhoto: [
            {Caption: null, Path: null},
            {Caption: null, Path: null},
            {Caption: null, Path: null},
            {Caption: null, Path: null}
          ]
        }]
      }
    }
  },
  methods: {
    fetchUser: function () {
      let self = this
      API.get('ezietruckapi', '/api/users').then((json) => {
        self.userItems = json['Users']
      })
    },
    handleDeleteVehicle: function (idx) {
      if (this.formData.Vehicles.length > 1) {
        if (this.formData.Vehicles[idx].PK !== '-') {
          let  vm = this
          API.post('ezietruckapi', `/api/vehicles/delete`, {body: {'PK': this.formData.Vehicles[idx].PK, 'SK': this.formData.Vehicles[idx].SK}}).then(() => {
            vm.formData.Vehicles = [...vm.formData.Vehicles.slice(0, idx), ...vm.formData.Vehicles.slice(idx + 1)]    
          })
        }
        this.formData.Vehicles = [...this.formData.Vehicles.slice(0, idx), ...this.formData.Vehicles.slice(idx + 1)]
      }
    },
    handleAddVehicle: function () {
      if (this.formData.Vehicles.length < 3) {
        this.formData.Vehicles = [...this.formData.Vehicles, {
          PK: '-',
          SK: '-',
          VehicleLicenseNumber: null,
          VehicleLicenseProvince: null,
          VehicleStatus: null,
          VehicleGroup: null,
          VehicleTruckType: null,
          VehicleContainerType: null,
          VehicleLoadCapacity: null,
          VehicleBrand: null,
          VehiclePurchasedYear: null,
          VehicleInsurranceAmount: null,
          VehicleFuelChargePerKM: null,
          VehiclePhoto: [
            {Caption: null, Path: null},
            {Caption: null, Path: null},
            {Caption: null, Path: null},
            {Caption: null, Path: null}
          ]
        }]
      }
    },
    fetchOptions: function () {
      let self = this
      API.get('ezietruckapi', `/api/options/TruckType`).then((json) => {
        self.truckTypeOptions = json.map((j) => j.Name)
      })
      API.get('ezietruckapi', `/api/options/ContainerType`).then((json) => {
        self.containerTypeOptions = json.map((j) => j.Name)
      })
      API.get('ezietruckapi', `/api/options/Bank`).then((json) => {
        self.bankOptions = json.map((j) => j.Name)
      })
      API.get('ezietruckapi', `/api/options/DriverTeam`).then((json) => {
        self.driverTeamOptions = json.map((j) => j.Name)
      })
      API.get('ezietruckapi', `/api/options/Tag`).then((json) => {
        self.driverTagOptions = json.map((j) => j.Name)
      })
    },
    fetchData: function () {
      if (this.$route.params.driverID) {
        API.get('ezietruckapi', `/api/drivers/${this.$route.params.driverID}`).then((json) => {
          for (let j of json) {
            if (j.SK.startsWith('#METADATA#')) {
              this.formData.PK = j.PK
              this.formData.SK = j.SK
              this.formData.DriverID = j.DriverID || null
              this.formData.DriverCitizenID = j.DriverCitizenID || null
              this.formData.DriverName = j.DriverName || null
              this.formData.DriverTeam = j.DriverTeam || null
              this.formData.DriverAddress = j.DriverAddress || null
              this.formData.DriverLicenseID = j.DriverLicenseID || null
              this.formData.DriverLicenseExpire = j.DriverLicenseExpire || null
              this.formData.DriverLicensePhoto = j.DriverLicensePhoto || null
              this.formData.DriverPhoto = j.DriverPhoto || null
              this.formData.DriverPhoneNumber = j.DriverPhoneNumber || null
              this.formData.DriverEmail = j.DriverEmail || null
              this.formData.DriverDepositAmount = j.DriverDepositAmount || null
              this.formData.DriverBankName = j.DriverBankName || null
              this.formData.DriverBankBranchCode = j.DriverBankBranchCode || null
              this.formData.DriverBankAccountName = j.DriverBankAccountName || null
              this.formData.DriverBankAccountNumber = j.DriverBankAccountNumber || null
              this.formData.DriverBookBankPhoto = j.DriverBookBankPhoto || null
              this.formData.DriverMonthlySalary = j.DriverMonthlySalary || null
              this.formData.DriverGroup = j.DriverGroup || null
              this.formData.DriverTags = j.DriverTags || []
              this.formData.NoDiaryPD = j.NoDiaryPD || 0
              this.formData.LineUserID = j.LineUserID || null,
              this.formData.RichMenuID = j.RichMenuID || null
              this.formData.LineMenuStatus = j.LineMenuStatus || null
              this.formData.ApprovedBy = j.ApprovedBy || null
              this.formData.BeginDate = j.BeginDate || null
              this.formData.RecruitedBy = j.RecruitedBy || null
              this.formData.Status = j.Status || null
              if (j.LastLocation) {
                this.formData.LastLocation
              }
              if (j.LastGPSUpdatedAt) {
                this.formData.LastGPSUpdatedAt
              }
            }
            if (j.SK.startsWith('VEHICLE#')) {
              if (this.formData.Vehicles[0].VehicleLicenseNumber) {
                this.formData.Vehicles.push({
                  PK: j.PK,
                  SK: j.SK,
                  VehicleLicenseNumber: j.VehicleLicenseNumber,
                  VehicleLicenseProvince: j.VehicleLicenseProvince,
                  VehicleStatus: j.VehicleStatus,
                  VehicleGroup: j.VehicleGroup,
                  VehicleTruckType: j.VehicleTruckType,
                  VehicleContainerType: j.VehicleContainerType,
                  VehicleLoadCapacity: j.VehicleLoadCapacity,
                  VehicleBrand: j.VehicleBrand,
                  VehiclePurchasedYear: j.VehiclePurchasedYear,
                  VehicleInsurranceAmount: j.VehicleInsurranceAmount,
                  VehicleFuelChargePerKM: j.VehicleFuelChargePerKM,
                  VehiclePhoto: (j.VehiclePhoto && j.VehiclePhoto.length > 0) ? [...j.VehiclePhoto] : [{Caption: null, Path: null}, {Caption: null, Path: null}, {Caption: null, Path: null}, {Caption: null, Path: null}]
                })
              } else {
                this.formData.Vehicles[0].PK = j.PK
                this.formData.Vehicles[0].SK = j.SK
                this.formData.Vehicles[0].VehicleLicenseNumber = j.VehicleLicenseNumber || null
                this.formData.Vehicles[0].VehicleLicenseProvince = j.VehicleLicenseProvince || null
                this.formData.Vehicles[0].VehicleStatus = j.VehicleStatus || null
                this.formData.Vehicles[0].VehicleGroup = j.VehicleGroup || null
                this.formData.Vehicles[0].VehicleTruckType = j.VehicleTruckType || null
                this.formData.Vehicles[0].VehicleContainerType = j.VehicleContainerType || null
                this.formData.Vehicles[0].VehicleLoadCapacity = j.VehicleLoadCapacity || null
                this.formData.Vehicles[0].VehicleBrand = j.VehicleBrand || null
                this.formData.Vehicles[0].VehiclePurchasedYear = j.VehiclePurchasedYear || null
                this.formData.Vehicles[0].VehicleInsurranceAmount = j.VehicleInsurranceAmount || null
                this.formData.Vehicles[0].VehicleFuelChargePerKM = j.VehicleFuelChargePerKM || null
                if (j.VehiclePhoto && j.VehiclePhoto.length > 0) {
                  this.formData.Vehicles[0].VehiclePhoto = [...j.VehiclePhoto]
                }
              }
            }
          }
          this.formData = Object.assign({}, this.formData)
        })
      }
    },
    formValidate: function () {
      let p = validate(this.submitForm, schema.DriverFormSchema)
      this.errors = {}
      for (let err of p.errors) {
        this.errors[err.property] = err.message
      }
      this.errors = Object.assign({}, this.errors)
    },
    handleImageSelect: function (event) {
      for (let file of event) {
        this.$Amplify.Storage.put(
          `Driver_Profile_Images/${this.formData.DriverID}.`+ file.name, file, { level: 'public' }
        ).then((res) => {
          this.formData.DriverPhoto = res.key
        }).catch(console.error)
      }
    },
    handleBookBankImageSelect: function (event) {
      for (let file of event) {
        this.$Amplify.Storage.put(
          `Driver_Profile_Images/${this.formData.DriverID}.`+ file.name, file, { level: 'public' }
        ).then((res) => {
          this.formData.DriverBookBankPhoto = res.key
        }).catch(console.error)
      }
    },
    handleLicenseImageSelect: function (event) {
      for (let file of event) {
        this.$Amplify.Storage.put(
          `Driver_Profile_Images/${this.formData.DriverID}.`+ file.name, file, { level: 'public' }
        ).then((res) => {
          this.formData.DriverLicensePhoto = res.key
        }).catch(console.error)
      }
    },
    handleVehicleImageSelect: function (vid, pid, event) {
      for (let file of event) {
        this.$Amplify.Storage.put(
          `Vehicle_Profile_Images/${this.formData.DriverID}.`+ file.name, file, { level: 'public' }
        ).then((res) => {
          this.formData.Vehicles[vid].VehiclePhoto[pid].Path = res.key
        }).catch(console.error)
      }
    },
    handleCreateDriver: function () {
      this.formValidate()
      if (Object.keys(this.errors).length == 0) {
        this.hideSubmit = true
        API.post('ezietruckapi', '/api/drivers', {body: this.submitForm}).then(() => {
          this.showSnackbar = true
          this.snackBarMsg = 'Successfully saved'
          this.hideSubmit = false
          this.$router.push('/Drivers')
        }).catch((e) => {
          this.showSnackbar = true
          this.snackBarMsg = e.response.data.message || e.message
          this.hideSubmit = false
        })
      } else {
        this.showSnackbar = true
        this.snackBarMsg = JSON.stringify(this.errors)
        this.hideSubmit = false
      }
    },
    checkDriver: async function (value) {
      if (value) {
        await API.get('ezietruckapi', `/api/customers/${value}`).then((json) => {
          if (json && json.length > 0) {
            this.errors['instance.DriverID'] = 'DriverID already exist'
            this.errors = Object.assign({}, this.errors)
          }
        }).catch(console.error)
      }
    }
  },
  computed: {
    ...mapGetters(['user']),
    submitForm () {
      let form = JSON.parse(JSON.stringify(this.formData))
      for (let propName of ['DriverAddress', 'DriverLicenseExpire', 'DriverLicensePhoto', 'DriverPhoto', 'DriverPhoneNumber',
        'DriverEmail', 'DriverDepositAmount', 'DriverBankName', 'DriverBankBranchCode', 'DriverBankAccountNumber',
        'DriverBankAccountName', 'DriverMonthlySalary', 'DriverBookBankPhoto', 'DriverLicenseID', 'DriverGroup',
        'DriverTeam', 'DriverTags', 'ApprovedBy', 'LineUserID', 'RichMenuID', 'LineMenuStatus', 'BeginDate', 'RecruitedBy', 'Status']) {
        if (!form[propName]) {
          delete form[propName];
        }
      }
      form.DriverCitizenID = form.DriverID
      let vehicles = []
      for (let vehicle of form.Vehicles) {
        if (vehicle.VehicleLicenseNumber) {
          for (let propName of ['VehicleStatus', 'VehicleGroup', 'VehicleLoadCapacity', 'VehicleBrand', 'VehiclePurchasedYear', 'VehicleInsurranceAmount','VehicleFuelChargePerKM']) {
            if (!vehicle[propName]) {
              delete vehicle[propName];
            }
          }
          vehicle.VehiclePhoto = vehicle.VehiclePhoto.filter((p) => !!p.Path)
          vehicles.push(vehicle)
        }
      }
      form.Vehicles = vehicles
      return form
    },
    userOptions: function () {
      return this.userItems.map((u) => {
        let idx = u.Attributes.findIndex((a) => a.Name === 'email')
        if (idx > -1) {
          return u.Attributes[idx].Value
        }
      })
    }
  },
  created () {
    this.fetchData()
    this.fetchOptions()
    this.fetchUser()
  }
}
</script>
